import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

export const query = gql`
  query GroupEventRsvp($id: String!, $userId: String!) {
    GroupEventRSVPs(where: { event: { equals: $id }, user: { equals: $userId } }) {
      docs {
        id
        status
      }
    }
  }
`

export interface EventRsvpQueryInput {
  id: string
  userId: string
}

export interface EventRsvpQueryOutput {
  GroupEventRSVPs: {
    docs: {
      id: string
      status: 'going' | 'notGoing' | 'maybe'
    }[]
  }
}

export type GroupEventRsvpStatus = EventRsvpQueryOutput['GroupEventRSVPs']['docs'][0]['status']

export const useGroupEventRsvpQuery = (
  options: QueryHookOptions<EventRsvpQueryOutput, EventRsvpQueryInput>
) => usePersistedCacheQuery<EventRsvpQueryOutput, EventRsvpQueryInput>(query, options)

export const groupEventRsvpQuery = {
  query,
}
